// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dLAC","colBig":"styles_colBig__Xo2nH","colSmall":"styles_colSmall__1AskX","shopifyNameWrapper":"styles_shopifyNameWrapper__2spX4"};